export const PACKAGED_APP_STATUS = {
  Unknown: 'Unknown',
  Trusted: 'Trusted',
  Untrusted: 'Untrusted',
};

const PACKAGED_APP_STATUS_MAPPING = [
  { value: PACKAGED_APP_STATUS.Unknown, label: 'No Status', color: '#9E9E9E' },
  { value: PACKAGED_APP_STATUS.Trusted, label: 'Trusted', color: '#4CAF50' },
  { value: PACKAGED_APP_STATUS.Untrusted, label: 'Untrusted', color: '#F44336' },
];

export const getPackagedAppStatusLabel = value =>
  PACKAGED_APP_STATUS_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getPackagedAppStatusColor = value =>
  PACKAGED_APP_STATUS_MAPPING.find(item => item.value === value)?.color || '#9E9E9E';

export const getPackagedAppStatusOptions = () =>
  PACKAGED_APP_STATUS_MAPPING.map(({ value, label }) => ({ value, label }));
